import { createAction, getEntities } from "../../actions/actionUtils.js";
import { ROUTES } from "../../../constants/routing.js";
import {
  CHARGE,
  USAGE,
  MEASUREMENTS,
  ENTITIES
} from "../../actions/actionConstants.js";

const getCharge = (id, from, to) => {
  // construct payload
  let payload = { "@id": id };
  if (from) payload.from = from;
  if (to) payload.to = to;

  return createAction(CHARGE.GET, payload);
};

const getUsage = (id, from, to) => {
  // construct payload
  let payload = { "@id": id };
  if (from) payload.from = from;
  if (to) payload.to = to;

  return createAction(USAGE.GET, payload);
};

const getMeasurements = (id, from, to) => {
  // construct payload
  let payload = { "@id": id };
  if (from) payload.from = from;
  if (to) payload.to = to;

  return createAction(MEASUREMENTS.GET, payload);
};

export function getEntityUsers(atId, searchParams, dependencies) {
  return getEntities(
    ENTITIES,
    `${atId}${ROUTES.USERS}`,
    dependencies,
    searchParams
  );
}

// using the following export pattern so we can mock more easily using jest

const entityActions = {
  getCharge,
  getUsage,
  getMeasurements,
  getEntityUsers
};

export default entityActions;
